/**
 * WebApp Solica
 * http://docs.90tech.fr/solica
 *
 * Copyright 2014 Zenlabs
 * Non permissive commercial License.
 */

;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('SessionService', SessionService)

  SessionService.$inject = ['$sessionStorage', 'zlAuth']

  /**
   *   Use this service instead of accessing $sessionStorage directly
   *   to ensure the errors (unset values) are dealt with.
   */
  function SessionService ($sessionStorage, zlAuth) {
    var self = this

    //
    _.extend(self, {
      getCompany: getCompany,
      getUser: getUser,
      getRoles: getRoles,
      isAdmin: isAdmin,
      isValidator: isValidator,
      isLoaded: isLoaded
    })

    /**
     * Return the company from sessionStorage
     * @returns {Company}
     */
    function getCompany () {
      return $sessionStorage.company
    }

    /**
     * Return the user form sessionStorage
     * @returns {User}
     */
    function getUser () {
      return $sessionStorage.user
    }

    function getRoles () {
      return $sessionStorage.roles
    }

    function isAdmin () {
      return _.includes($sessionStorage.roles, 'admin')
    }

    function isValidator () {
      return _.includes($sessionStorage.roles, 'validator') || isAdmin()
    }

    function isLoaded () {
      return zlAuth.getToken()
    }
  }
})(window.angular, window._)
